import { mountApp } from './ui/app.js';
import './ui/style.css';

mountApp(document.getElementById('app') as HTMLElement);
